import { render } from "./AllOrders.vue?vue&type=template&id=03dedf2c&scoped=true"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"

import "./AllOrders.vue?vue&type=style&index=0&id=03dedf2c&lang=scss&scoped=true"
import "./AllOrders.vue?vue&type=style&index=1&id=03dedf2c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dedf2c"],['__file',"src/components/orders/AllOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03dedf2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03dedf2c', __exports__)) {
    console.log('reload')
    api.reload('03dedf2c', __exports__)
  }
  
  module.hot.accept("./AllOrders.vue?vue&type=template&id=03dedf2c&scoped=true", () => {
    console.log('re-render')
    api.rerender('03dedf2c', render)
  })

}


export default __exports__